import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTranslation } from 'react-i18next';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation();

  // Charger les éléments de la FAQ depuis le fichier de traduction
  const faqItems = t('faq-faq.items', { returnObjects: true });

  // Vérifier si faqItems est un tableau
  if (!Array.isArray(faqItems)) {
    console.error('Les données FAQ ne sont pas un tableau :', faqItems);
    return null; // Arrêter le rendu si les données sont incorrectes
  }

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index); // Basculer l'ouverture et la fermeture des réponses
  };

  return (
    <div className="faq-container">
      <h2 className="text-center mb-5 no-dark-mode">{t('faq-faq.title')}</h2>
      {faqItems.map((item, index) => (
        <div className="faq-item" key={index}>
          <div
            className={`faq-question ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleFAQ(index)}
          >
            {item.question}
          </div>
          {activeIndex === index && (
            <div className="faq-answer">
              {item.answer.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQ;
